<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品名称/UDI编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称/UDI编码" v-model="searchParam"></a-input>
                </a-form-item>
              </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- 操作按钮区域 -->

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="getDetail(record)">详情</a>

            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="blue">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->

      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { ledgerDelete,ledgerEdit,rcRecordSwitch } from '@/api/api'
import JDate from '@/components/jeecg/JDate'
import { PIadmin } from '@/api/manage'


export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin],
  components: {

    JDate,
  },
  data() {
    return {
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      // queryParam: {
      //   // page: 1,
      //   // limit: 20,
      //   // keywords: '',
      //   // specification: '',
      //   // codeSystem:''
      // },
      searchParam: '',
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '产品名称', dataIndex: 'productName', width: 220 ,ellipsis: true, render: (text) => text || "--" },
        { title: '产品UDI', dataIndex: 'productDi', width: 300, render: (text) => text || "--" },
        { title: '品类编码', dataIndex: 'productNo',width: 120, render: (text) => text || "--"},
        { title: '生产批号', dataIndex: 'batchNumber', width: 150, render: (text) => text || "--" },
        { title: '生产日期', dataIndex: 'startDate',width: 160, render: (text) => text || "--"},
        { title: '灭菌批号', dataIndex: 'dBatchNumber', width: 160, render: (text) => text || "--" },
        { title: '失效日期', dataIndex: 'endDate',width: 150, render: (text) => text || "--"},
        { title: '有效期', dataIndex: 'effectiveDate', width: 160, render: (text) => text || "--" },
        { title: '最后验证时间', dataIndex: 'checkTime',width: 160, render: (text) => text || "--"},
        { title: '验证次数', dataIndex: 'successNum', width: 100, render: (text) => text || "--" },
        { title: '防伪验证', dataIndex: 'piSecurityCode',width: 100,  render: (text) => text || "--"},

      ],
      url: {
        list: '/productPi/piSecurityList',

      },
    }
  },
  computed: {},
  created() {

  },
  methods: {

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    //打开详情
    getDetail(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalDetail.initShow(record)
    },
    addLicense(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalLicense.initShow(record)
    },
    async handleAudit(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //handleAuditCancel
    async handleAuditCancel(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },

    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ledgerDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>